<template>
  <v-container>
    <v-row>
      <v-col class="d-flex align-center" :class="{ 'mt-3': !hideLink }">
        <h2 class="primary--text font-weight-bold">{{ entry.name }}</h2>
        <p class="mb-n1 ml-2">{{ entry.vendor ? '(Vendor)' : '' }}</p>
        <v-btn
          v-if="!hideLink"
          :to="{ name: 'NPC', params: { slug: entry.name.toLowerCase().replace(/-/g, '§-').replace(/ /g, '-') } }"
          icon
        >
          <v-icon color="primary">
            mdi-open-in-new
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-divider />
    <v-row no-gutters v-if="entry.description">
      <v-col cols="12">
        <v-subheader class="pl-0 mb-n2">Description</v-subheader>
      </v-col>
      <v-col lg="12" style="white-space: pre-line;">
        {{ entry.description }}
      </v-col>
    </v-row>
    <v-row no-gutters v-if="entry.Acts.length">
      <v-col cols="12">
        <v-subheader class="pl-0 mb-n2">Acts</v-subheader>
      </v-col>
      <v-col lg="12" style="white-space: pre-line;">
        {{ entry.Acts.map(n => n.name).join(', ') }}
      </v-col>
    </v-row>
    <v-row no-gutters v-if="entry.NPCTraits.length">
      <v-col cols="12">
        <v-subheader class="pl-0 mb-n2">Traits</v-subheader>
      </v-col>
      <v-col lg="12" style="white-space: pre-line;" v-for="(trait, i) in entry.NPCTraits" :key="`trait-${i}`">
        {{ trait.name }}{{ trait.NPCNPCTraits.description ? `: ${trait.NPCNPCTraits.description.replace(/\n/g, ' ').replace(/  /g, ' ')}` : '' }}
      </v-col>
    </v-row>
    <v-row no-gutters v-if="entry.Quests.length">
      <v-col cols="12">
        <v-subheader class="pl-0 mb-n2">Starts Quests</v-subheader>
      </v-col>
      <v-col lg="12">
        <v-chip
          v-for="(q, i) in entry.Quests"
          :key="`quest-${i}`"
          class="mr-2 mb-1"
          outlined
          :to="{ name: 'Quest', params: { slug: q.name.toLowerCase().replace(/-/g, '§-').replace(/ /g, '-') } }"
        >
          {{ q.name }}
        </v-chip>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <v-subheader class="pl-0 mb-n2">Found in Locations</v-subheader>
      </v-col>
      <v-col lg="12">
        <v-chip
          v-for="(q, i) in entry.canBeFoundInLocations"
          :key="`loc-${i}`"
          class="mr-2 mb-1"
          outlined
          :to="{ name: 'Location', params: { slug: q.name.toLowerCase().replace(/-/g, '§-').replace(/ /g, '-') } }"
        >
          {{ q.name }}
        </v-chip>
      </v-col>
    </v-row>
    <v-row no-gutters v-if="entry.sellsItemTypes.length">
      <v-col cols="12">
        <v-subheader class="pl-0 mb-n2">Sells Item Types</v-subheader>
      </v-col>
      <v-col lg="12">
        <v-chip
          v-for="(q, i) in entry.sellsItemTypes"
          :key="`item-type-${i}`"
          class="mr-2 mb-1"
          outlined
        >
          {{ q.name }}
        </v-chip>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'DetailedNPC',
  props: {
    entry: Object,
    hideLink: {
      type: Boolean,
      default: false
    }
  }
}
</script>
